export default __webpack_public_path__ + "static/MoCuts-503ae546a2686e66ec20788db3a3b038.webp";